import { render } from "./Permission.vue?vue&type=template&id=d0bff10a&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=d0bff10a&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0bff10a"]])

export default __exports__